export default "__VITE_ASSET__I2LIXuF4__"